import { IVerifyDriverBackgroundResponse } from "../../utils/types";
import { apiManager } from "../api-manager";

export const verifyDriverBackground = async (id: string) => {
  const res = await apiManager.post<IVerifyDriverBackgroundResponse>(
    `/admin/driver/${id}/background-check`
  );
  return res;
};
